import React, { useCallback } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useEffect } from "react";
import { fetchCustomerFeed, fetchShopVip, fetchNoCommentOrder } from "../../../../../../api";
import { useState } from "react";
import TopMeIcon from "../fragments/top-icon/index"
import NotificationSwiper from "../fragments/notification-swiper/index";
import UserInfo from "../fragments/user-info";
import { useMemo } from "react";
import UserService from "../fragments/user-service";
import UserRecommend from "../fragments/recommend/index"
import Cookies from "js-cookie";
import NormalConfigConfirm from "../../../../../components/alert/config-confirm";
import { useIntl } from "react-intl";
import { TOGGLE_UI_LOGIN } from "../../../../../../store/actions/ui";
import { action_fetch_customer } from "../../../../../../store/actions/pages/customer";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Cache from "../../../../../../utils/cache";

export default props =>{
    useStyles(cls);
    const { customer } = props;
    const [feed, setFeed] = useState(null);
    const [showVip, setShopVip] = useState(false);
    const Intl = useIntl();
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(async () =>{
        if(customer?.id){
            let response = await fetchCustomerFeed(customer?.id);
            if(response?.code === 200 && response?.result){
                setFeed(response?.result);
            }
        }
    }, [customer?.id]);

    useEffect(async () =>{
        let response = await fetchShopVip();
        if(response?.code === 200 && response?.result){
            setShopVip(true);
        }
    }, []);

    useEffect(async () =>{ 
        let cookieValue = Cookies.get('_has_no_comment_order');
        if(customer?.id){
            let response = await fetchNoCommentOrder();
            if(response?.code === 200 && response?.result){
                if(!cookieValue){
                    Cookies.set('_has_no_comment_order', 1, { path: '/', expires: 1 });

                    NormalConfigConfirm({
                        boxStyle:{
                            width: '250px',
                            borderRadius: '2px',
                            padding: '26px 25px'
                        },
                        close:{},
                        message:{
                            text: Intl.formatMessage({ id: "no_comment_order", defaultMessage: "You have unreviewed orders, go and share your experience to earn more points!" }),
                            style:{},
                        },
                        btn1:{
                            text: Intl.formatMessage({ id: "ok", defaultMessage: "Ok" }),
                            clickHandle:() =>{
                                window.location.href = '/user/order/confirmed';
                            }
                        }
                    });
                }
            }
        }else{
            Cookies.remove('_has_no_comment_order');
        }
    }, [customer?.id]);

    const isLogin = useMemo(() =>{
        return !!customer?.id;
    },[customer])

    const isVipUser = useMemo(() =>{
        if(showVip && customer?.vipUser){
            return true;
        }else{
            return false;
        }
    }, [showVip, customer]);

    const locationOrPushState = useCallback((path, difference) =>{
        if(difference){
            history.push(path);
        }else{
            window.location.href = path;
        }
    }, []);

    const showNewIcon = useMemo(() =>{
        if(isVipUser){
            let cacheLevel = Cache.get('customer_vip_level');
            let customerLevel = customer?.vipUser?.level;
            if(customerLevel > cacheLevel || (cacheLevel == null && customerLevel > 0)){
                return true;
            }else{
                return false;
            }
        }else{
            return false;
        }
    }, [isVipUser, customer]);

    const checkoutLoginStatus = useCallback((path, difference) =>{
        if(!isLogin){
            dispatch({
				type: TOGGLE_UI_LOGIN,
				payload: {
					showLogin: true,
					eventType: "me",
                    redirectUrl: path,
					callBack: async function () {
                        await dispatch(action_fetch_customer())
                        locationOrPushState(path, difference);
                        window?.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        })
					}
				}
			})
        }else{
            locationOrPushState(path, difference);
        }
    }, [isLogin]);

    const onlyCheckoutLoginHandle = useCallback(() =>{
        if(!isLogin){
            dispatch({
				type: TOGGLE_UI_LOGIN,
				payload: {
					showLogin: true,
					eventType: "me", 
                    callBack: async function () {
                        await dispatch(action_fetch_customer());
                        window?.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        })
					}
				}
			})
        }
    }, [isLogin]);

    return <div className={cls.MainContainer}>
        <TopMeIcon {...props} customer={customer} checkoutLoginStatus={checkoutLoginStatus} />

        <NotificationSwiper {...props} onlyCheckoutLoginHandle={onlyCheckoutLoginHandle} />

        <UserInfo {...props} showNewIcon={showNewIcon} isLogin={isLogin} isVipUser={isVipUser} showVip={showVip} checkoutLoginStatus={checkoutLoginStatus} onlyCheckoutLoginHandle={onlyCheckoutLoginHandle} />

        <UserService {...props} customer={customer} showNewIcon={showNewIcon} isLogin={isLogin} feed={feed} isVipUser={isVipUser} checkoutLoginStatus={checkoutLoginStatus} />

        <UserRecommend {...props} isLogin={isLogin} onlyCheckoutLoginHandle={onlyCheckoutLoginHandle} />
    </div>
}